import { omitBy, isUndefined } from 'lodash';

export const CHAT_AGENT_ACTION_BUTTON_PROPS = {
    ICON: 'icon',
    TITLE: 'title',
    POST_ICON: 'postIcon',
    FLOW: 'flow',
};

const { ICON, TITLE, POST_ICON, FLOW } = CHAT_AGENT_ACTION_BUTTON_PROPS;

export const formatActionButton = ({ icon, title, postIcon, flow }) =>
    omitBy(
        {
            [ICON]: icon,
            [TITLE]: title,
            [POST_ICON]: postIcon,
            [FLOW]: flow,
        },
        isUndefined
    );
